//users
export const UPDATE_USERS_SUCCESS = 'UPDATE_USERS_SUCCESS';
export const GET_LOGGED_USER_SUCCESS = 'GET_LOGGED_USER_SUCCESS';
export const GET_IS_MFA_ENABLED_SUCCESS = 'GET_IS_MFA_ENABLED_SUCCESS';
export const GET_IS_ADD_USERNAME_IN_EMAIL_FORMAT_SUCCESS = 'GET_IS_ADD_USERNAME_IN_EMAIL_FORMAT_SUCCESS';
export const GET_USER_ROLES_SUCESS = 'GET_USER_ROLES_SUCESS';
export const ADD_ROLE_SUCESS = 'ADD_ROLE_SUCESS';
export const UPDATE_USER_ROLE_SUCESS = 'UPDATE_USER_ROLE_SUCESS';
export const UPDATE_ROLE_PERMISSIONS_SUCESS = 'UPDATE_ROLE_PERMISSIONS_SUCESS';
export const UPDATE_ROLE_SITES_SUCESS = 'UPDATE_ROLE_SITES_SUCESS';
export const REMOVE_ROLE_SUCESS = 'REMOVE_ROLE_SUCESS';
